export interface Media {
	id: string;
	mimeType: string;
	url: string;
	size?: number;
	metadata?: Metadata;
	versions?: string[];
	displayName: string;
}
export interface Metadata {
	width?: number;
	height?: number;
	placeholder?: string;
	versions?: string[];

	/** VIDEO */
	durationMs?: number;
	playlist?: string;
	thumbnail?: string;
	status?: TranscodingStatus;
	progress?: number;
}

export interface MediaUploadInfos {
	key: string;
	uploadId: string;
	partUrls: string[];
}

export type TranscodingStatus = "IN_PROGRESS" | "COMPLETED" | "ON_ERROR";

export const allAssetTypes = ["IMAGE", "VIDEO", "DOCUMENT", "AUDIO"] as const;
export type AssetType = (typeof allAssetTypes)[number];
